import * as yup from 'yup';

import CrudPage from '@modules/cruds/CrudPage';
import { defaultConfigComponent } from './DistributionConfigurations';
import DistributionConfigurationForm from './DistributionConfigurationPageForm';

const distConfigSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  distributionConfigLists: yup.array().required().label('Distribution List'),
});

const DistributionConfigurationPage = props => {
  return (
    <CrudPage
      key={'distConfigurationPage'}
      configComponent={defaultConfigComponent}
      form={DistributionConfigurationForm}
      methodCRUD="put"
      validationSchema={distConfigSchema}
    />
  );
};

export default DistributionConfigurationPage;
